import { Controller } from "react-hook-form";
import { Typography } from "@mui/material";
import TextField from "@mui/material/TextField";

import { FormInputProps } from "./FormInputProps";
import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import { getValue } from "../../utils";
import { fontSize } from "../../styles/mui/styles/font";

export const FormInputText = ({
  control,
  dataTestId,
  disabled,
  handleChange,
  helper,
  label,
  maxRow,
  multiline,
  name,
  onKeyPress,
  placeholder,
  searchInputRef,
  textLength,
  InputStyle,
  inputVariant,
  inputRows,
  readOnly,
}: FormInputProps) => {
  let props = {};
  if (inputRows) {
    props = {
      rows: inputRows,
    };
  } else {
    props = {
      maxRows: maxRow || 2,
    };
  }
  return (
    <Controller
      name={name}
      control={control}
      rules={helper}
      render={({
        field: { onChange, value, ref, onBlur },
        fieldState: { error },
      }) => (
        <TextField
          required={getValue(helper, "required.value", false)}
          error={error !== undefined}
          helperText={error ? error.message : ""}
          {...props}
          onChange={(e) => {
            onChange(e);
            handleChange && handleChange(e);
          }}
          onBlur={onBlur}
          value={value || ""} // handle null/undefined
          onKeyUp={(e) => {
            onKeyPress && onKeyPress(e);
          }}
          fullWidth
          sx={{
            ...InputStyle,
            "& .MuiInputBase-input": {
              fontSize: fontSize[12],
            },
          }}
          label={
            <Typography
              variant="h5"
              fontWeight={fontWeight[3]}
              color={colors.fonts[2]}
            >
              {label}
            </Typography>
          }
          placeholder={
            name.includes("streetName1") || name.includes("streetName2")
              ? "Add here..."
              : placeholder
          }
          disabled={disabled}
          multiline={multiline || false}
          slotProps={{
            htmlInput: {
              maxLength: textLength ? textLength : 50,
              ref: searchInputRef ? searchInputRef : null,
              autoComplete: "none",
            },
            input:{
              readOnly: readOnly ? true : false,
              
            }
          }}
          variant={inputVariant ? "outlined" : "standard"}
          inputRef={ref}
          InputLabelProps={{ shrink: true }}
          data-testid={dataTestId}
        />
      )}
    />
  );
};
